import client from "./axiosConfig";

export const getBills = (params) => {
  const config = {
    url: "/accounts/bills/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const getBillById = (id) => {
  const config = {
    url: `/accounts/bills/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const createBill = (data) => {
  const config = {
    url: `/accounts/bills/`,
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const updateBill = (id) => {
  const config = {
    url: `/accounts/bills/${id}/`,
    method: "PATCH",
  };
  const response = client(config);
  return response;
};

export const fetchCategories = (params) => {
  const config = {
    url: "/accounts/bill-categories/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const updateBillStatus = (id, data) => {
  const config = {
    url: `/accounts/bills/${id}/review/`,
    method: "PATCH",
    data,
  };
  return client(config);
};

export const deleteBill = (id) => {
  const config = {
    url: `/accounts/bills/${id}/`,
    method: "DELETE",
  };
  return client(config);
};

export const getBillsSite = (id) => {
  const config = {
    url: "/accounts/sites/",
    method: "GET",
  };
  const response = client(config);
  return response;
}

export const getAdvanceNotes = (params) => {
  const config = {
    url: "accounts/advance-notes/",
    method: "GET",
    params
  }
  const response = client(config);
  return response;
}

export const getAdvanceNoteById = (id) => {
  const config = {
    url: `/accounts/advance-notes/${id}/`,
    method: "GET",
  }
  const response = client(config);
  return response;
}

export const createAdvanceNote = (data) => {
  const config = {
    url: `/accounts/advance-notes/`,
    method: "POST",
    data,
  }
  const response = client(config);
  return response;
}

export const updateAdvanceNote = (id, data) => {
  const config = {
    url: `/accounts/advance-notes/${id}/`,
    method: "PATCH",
    data,
  }
  const response = client(config);
  return response;
}

export const deleteAdvanceNote = (id) => {
  const config = {
    url: `/accounts/advance-notes/${id}/`,
    method: "DELETE",
  }
  const response = client(config);
  return response;
}

export const getUserLedger = (params) => {
  const config = {
    url: "/accounts/user-ledger/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
}

export const getProjectLedger = (params) => {
  const config = {
    url: "/accounts/project-ledger/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
}